import { useState } from 'react';
import { CalendarDays, Clock3 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Dialog, DialogDescription, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { PortalDialogContent as DialogContent } from './PortalDialogContent';

const DAYS = [
  ['monday', 'Monday'], ['tuesday', 'Tuesday'], ['wednesday', 'Wednesday'],
  ['thursday', 'Thursday'], ['friday', 'Friday'], ['saturday', 'Saturday'], ['sunday', 'Sunday'],
];

const branchDate = (timezone) => {
  try {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: timezone || 'Africa/Accra', weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(new Date()).map(part => [part.type, part.value]));
    return { date: `${parts.year}-${parts.month}-${parts.day}`, day: parts.weekday.toLowerCase() };
  } catch {
    const now = new Date();
    return { date: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`,
      day: DAYS[(now.getDay() + 6) % 7][0] };
  }
};
const hoursText = item => item?.closed ? 'Closed' : `${item?.opens || '—'}–${item?.closes || '—'}`;

export const PortalHours = ({ openingHours, branchName }) => {
  const [open, setOpen] = useState(false);
  if (!openingHours?.weekly) return null;
  const branchToday = branchDate(openingHours.timezone);
  const today = branchToday.date;
  const holiday = (openingHours.holidays || []).find(item => item.date === today);
  const key = branchToday.day;
  const current = holiday || openingHours.weekly[key];
  const status = `${holiday?.label ? `${holiday.label} · ` : ''}${hoursText(current)}`;
  const upcoming = (openingHours.holidays || []).filter(item => item.date >= today).slice(0, 8);
  return <>
    <Button variant="link" size="sm" className="h-auto p-0 text-xs gap-1.5" onClick={() => setOpen(true)} data-testid="portal-opening-hours-button">
      <Clock3 className="w-3.5 h-3.5" /><span data-testid="portal-opening-hours-today">Today: {status}</span>
    </Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent data-testid="portal-opening-hours-dialog">
      <DialogHeader><DialogTitle>Opening hours · {branchName}</DialogTitle><DialogDescription>Regular hours and upcoming holiday changes.</DialogDescription></DialogHeader>
      <div className="divide-y" data-testid="portal-opening-hours-weekly">
        {DAYS.map(([day, label]) => <div key={day} className="flex justify-between gap-4 py-2 text-sm"><span>{label}</span><span className="font-medium" data-testid={`portal-public-hours-${day}`}>{hoursText(openingHours.weekly[day])}</span></div>)}
      </div>
      {!!upcoming.length && <div className="border-t pt-4"><h3 className="font-medium flex items-center gap-2"><CalendarDays className="w-4 h-4" />Holiday changes</h3>
        <div className="mt-2 space-y-2">{upcoming.map(item => <div key={item.date} className="flex justify-between gap-4 text-sm" data-testid={`portal-public-holiday-${item.date}`}><span>{item.date}{item.label ? ` · ${item.label}` : ''}</span><span className="font-medium">{hoursText(item)}</span></div>)}</div></div>}
    </DialogContent></Dialog></>;
};